module.exports = __webpack_public_path__ + "static/img/img_t3.37b60588.webp";